import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeNewbuildingBookingSuccess } from '../../../actions/newbuildingBooking';
import { NewbuildingBookingSuccessModal } from '../../../components/NewbuildingBookingSuccessModal';
import { getOfferCustomUrl } from '../../../selectors/analytics';
import { selectIsConfirmOpen, selectProfitbaseUrl } from '../../../selectors/newbuildingBooking';
import { trackBookingSuccess } from '../../../tracking/newbuildingBooking';

export const BookingSuccessModalContainer = () => {
  const isOpen = useSelector(selectIsConfirmOpen);
  const bookingUrl = useSelector(selectProfitbaseUrl);
  const customUrl = useSelector(getOfferCustomUrl);
  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(closeNewbuildingBookingSuccess());
  }, [dispatch]);

  const handleConfirm = React.useCallback(() => {
    dispatch(closeNewbuildingBookingSuccess());
    trackBookingSuccess(customUrl);
  }, [dispatch, customUrl]);

  return (
    <NewbuildingBookingSuccessModal
      confirmLink={bookingUrl}
      open={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
    />
  );
};
